const equipmentInfo = {
  service: 'Servicio',
  companies: 'Empresas',
  place: 'Lugar',
};

export default equipmentInfo;
